import {
    OBTENER_VARIABLES,
    AGREGAR_VARIABLE,
    ELIMINAR_VARIABLE,
    ACTUALIZAR_VARIABLE,
    VARIABLE_ERROR,
    VARIABLE_OK,
    VARIABLE_ACTUAL,
    OBTENER_VARIABLE,
    OBTENER_VARIABLE_TABLA
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_VARIABLES:
            return {
                ...state,
                variables: action.payload,
                loading: false
            }
        case OBTENER_VARIABLE_TABLA:
            return {
                ...state,
                variables: action.payload,
                loading: false
            }
        case VARIABLE_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case VARIABLE_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_VARIABLE:
            return {
                ...state,
                variables: [...state.variables, action.payload],
                formulario: false,
                errorformulario: false,
                mensaje: null,
            }
        case VARIABLE_ACTUAL:
            return {
                ...state,
                variable: state.variables.find(vari => vari.id === action.payload)
            }
        case ELIMINAR_VARIABLE:
            return {
                ...state,
                variables: state.variables.filter(vari => vari.id !== action.payload),
                variable: null
            }
        case ACTUALIZAR_VARIABLE:
            return {
                ...state,
                variable: action.payload,
                mensaje: null,
            }
        case OBTENER_VARIABLE:
            return {
                ...state,
                variable: action.payload
            }
        default:
            return state;
    }
}